export const situationsOne = [
  {
    id: 1,
    text: "While you board a train at the station, you find a suitcase beneath your seat. You would...",
    response:
      "Inquired Co-passengers, if it doesn't belong to anyone then informed RPF and handed over to them",
  },
  {
    id: 2,
    text: "You are playing in your friend's house when he gets struck with naked electric wire. You would...",
    response:
      "Rushed to the meter, tripped off MCB, and gave him medical assistance as needed.",
  },
  {
    id: 3,
    text: "A persistent call is coming on her mobile by an unknown person. She would...",
    response: "Attended the call, inquired the reason, and acted accordingly",
  },
  {
    id: 4,
    text: "Your friend has not invited you to his marriage party. You would...",
    response:
      "Respected his/her decision and congratulated them over the phone.",
  },
  {
    id: 5,
    text: "While firing crackers, a child gets severe burns on the hand. What would you do...",
    response:
      "Immediately gave icing, informed his/her parents, and took him/her to the hospital.",
  },
  {
    id: 6,
    text: "While going to the office, he saw a man climbing on a house with the help of a rope. He would...",
    response:
      "Inquire the reason, if found suspicious, caught him and hand him over to the owner and went for office.",
  },
  {
    id: 7,
    text: "He is asked to organize a variety show in the aid of jawan Welfare in his unit. He would...",
    response:
      "Take responsibility, prepare a team, make all arrangements, supervise the preparation, and make it a success.",
  },
  {
    id: 8,
    text: "He was traveling in a jungle and saw one person attacked by five burglars. He...",
    response:
      "Called police and ambulance, hospitalized the victim, and gave the necessary information to the police.",
  },
  {
    id: 9,
    text: "At a lonely place. He found two men misbehaving with a girl. He would...",
    response:
      "Call the police and give location while he engages them till the police come, used force if required and get them caught, and escort the girl to her destination.",
  },
  {
    id: 10,
    text: "It was the first day of her college. A boy started teasing her right from the entrance gate. She would... ",
    response: "Complain to the college management and seek remedy.",
  },
  {
    id: 11,
    text: "He felt that the work he is presently engaged is useless. He...",
    response:
      "Gave it some time, aroused some interest, and finished the work.",
  },
  {
    id: 12,
    text: "While returning from market, three persons with knife stop him and ask him to hand over his valuable possessions. He...",
    response:
      "Shouted for help, gathered passersby, nabbed them with the help of passersby, and handed them over to the police.",
  },
  {
    id: 13,
    text: "His friend lost his job and into financial difficulties. He...",
    response: "Supported him financially and help him find a new job.",
  },
  {
    id: 14,
    text: "You find that the person whom you call your friend has been cheating you. What would you do...",
    response: "Talk to him and make him realize his mistake.",
  },
  {
    id: 15,
    text: "Young men are not interested in joining defence forces. What incentive would you offer to lure them...",
    response:
      "Life full of adventure, respect, and honor. Security for family and military perk and an opportunity to serve the motherland in the best way possible.",
  },
  {
    id: 16,
    text: "Having passed intermediate, she wants to continue her education but her mother stops her in the house. She would...",
    response:
      "Tell mother about her dreams and passion and the benefits of further studies and convince her mother with the help of her father.",
  },
  {
    id: 17,
    text: "He is in the final year of his graduation and his father lost the job. He would...",
    response:
      "Take a paid internship or a part-time job. Support his family financially and help his father find a new job.",
  },
  {
    id: 18,
    text: " While traveling you found your suitcase missing from the seat. You...",
    response:
      "Inquired co-passengers if not found then lodge a complaint in the nearby police station.",
  },
  {
    id: 19,
    text: "In free period You wanted to study but your friends were continuously disturbing you. you...",
    response:
      "Requested them not to disturb and convinced them to do a group study.",
  },
  {
    id: 20,
    text: "After graduation, she has joined a job with the consent of her mother but her brother and father are against the job. She...",
    response:
      "She persuaded them by showing her professional progress and removing any misunderstandings regarding the job.",
  },
  {
    id: 21,
    text: "When his Boss does not agree with his views. He...",
    response:
      "He listened to the boss's opinion and clarified all doubts based on the facts.",
  },
  {
    id: 22,
    text: "Due to financial difficulties, his parents find it difficult to give him further education. He...",
    response:
      "He worked a part-time job, funded his education, and supported his family.",
  },
  {
    id: 23,
    text: "You receives an order from your CO to do certain work, but you feel that CO’s approach is wrong. You...",
    response:
      "Kept faith in CO’s decision, followed the order, and completed it successfully.",
  },
  {
    id: 24,
    text: "While traveling in a train, he came to know that someone has picked his pocket. He...",
    response: "Informed RPF and lodged a complaint.",
  },
  {
    id: 25,
    text: "While passing through a jungle, he finds a bag full of money. He...",
    response: "Took the bag and handed it over to the police.",
  },
  {
    id: 26,
    text: "Your friend's parents decided to take divorce. You...",
    response:
      "Persuaded them to undergo couple counseling and tried my best to make an amicable settlement and prevent the divorce.",
  },
  {
    id: 27,
    text: "He was traveling in a train during the night. A thief came and stole his bag and jumped off the train. He...",
    response:
      "Alerted co-passengers, Informed the RPF, and gave them inputs and location.",
  },
  {
    id: 28,
    text: "He was traveling in a train and found unusual activity by co-passenger. He...",
    response:
      "Kept sharp eye on the activity and if found suspicious, informed RPF.",
  },
  {
    id: 29,
    text: "He was attacked by a mob for being an atheist. He...",
    response: "He ran and took the help from police.",
  },
  {
    id: 30,
    text: "Her friend has come to her while talking she started weeping saying that a boy who is her neighbor has threatened to molest her. She would...",
    response:
      "Consolated her and helped her file a complaint at the police station and take immediate action against that boy.",
  },
  {
    id: 31,
    text: "You are in the second year of comp. engineering. But now you find it hard to complete your degree. You...",
    response:
      "Motivated myself, took assistance from seniors and professors, worked hard, and completed the degree.",
  },
  {
    id: 32,
    text: "You won a lottery of 1000000. What you do...",
    response:
      "Save some money, give some to charity, and invest remaining in a business.",
  },
  {
    id: 33,
    text: "His boss reprimanded him in presence of others. What will be his reaction...",
    response:
      "Listened to his boss’s opinion, analyzed and improved the mistakes, and impressed boss with better performance.",
  },
  {
    id: 34,
    text: " He is forced to vote for a candidate not of his choice. He...",
    response:
      "Complained to the authority of EC and voted for his choice of candidate.",
  },
  {
    id: 35,
    text: " His money is lost and he is new in town. He...",
    response:
      "He lodged a complaint in the police station and asked for assistance.",
  },
  {
    id: 36,
    text: "He saw a truck hit a cyclist on the highway. He...",
    response:
      "Ran to the spot, noted the truck number, stopped passing vehicle, took him to the hospital, and later called the police.",
  },
  {
    id: 37,
    text: " You are going to market with your sister and some boys start doing mischief with her. You...",
    response:
      "Confronted them with the help of passersby and got them arrested.",
  },
  {
    id: 38,
    text: "He was on his way to home and suddenly it started raining heavily. He...",
    response: "He opened his umbrella and reached home.",
  },
  {
    id: 39,
    text: "You are on the way to your home suddenly your bicycle got punctured. You...",
    response:
      "Took it to the nearby mechanic, got it repaired, and reached home.",
  },
  {
    id: 40,
    text: "During the exams, his teacher threatened him to fail in examination. He...",
    response:
      "Didn’t bother, focused on the exam, prepared well, and gave no reason to fail him, and later gathered the student support and complained to the management.",
  },
  {
    id: 41,
    text: "Your mom is seriously ill and your boss doesn’t grant you leave. You...",
    response:
      "Asked father/brother to take care of her, meanwhile completed all the pending work and got the leave.",
  },
  {
    id: 42,
    text: "During her examination while she was studying, she saw smoke and fire in her neighboring house. She would...",
    response:
      "Alert the neighbors, call fire brigade meanwhile gathered society members and help in evacuation and putting out the fire.",
  },
  {
    id: 43,
    text: "Light in your colony suddenly goes off due to rain and storm. You...",
    response: " Informed authority and enjoyed the weather.",
  },
  {
    id: 44,
    text: "While on morning walk she found a purse containing Rs. 5000 including the ATM card and driving license. She...",
    response: "Contacted the owner and handed it over.",
  },
  {
    id: 45,
    text: "While he is waiting for a bus, an accident took place in front of him. He...",
    response:
      "Rushed to the spot, took help from the commuter and got the injured hospitalized, and later informed the police.",
  },
  {
    id: 46,
    text: "He is going to attend an important meeting and he is already getting late. Suddenly the road is blocked due to traffic jam. He...",
    response: "Took another route and reached on time.",
  },
  {
    id: 47,
    text: "He is assigned a difficult task which he has not done earlier. He...",
    response:
      "Took the charge, took assistance from seniors and colleagues and completed the task assigned.",
  },
  {
    id: 48,
    text: "You are required to go for patrolling at higher in high altitude area. You do not have coat parka. You...",
    response: "Took it from a friend and did the patrolling.",
  },
  {
    id: 49,
    text: "His sister’s marriage is fixed. His relative refused to give loan/money. He...",
    response: "He took a wedding loan from the bank and performed the wedding.",
  },
  {
    id: 50,
    text: "Marriage of his sister is fixed. He is not granted leave due to Administrative Inspection. He...",
    response:
      "Informed the family about the situation, performed his duty, and reached home for vidaai ceremony.",
  },
  {
    id: 51,
    text: "He was trapped in a jungle with his girlfriend and thieves came and started teasing his girlfriend. He...",
    response:
      "Confronted them, used force to protect his girlfriend, escaped when given the opportunity, and called the police.",
  },
  {
    id: 52,
    text: "You saw your girlfriend walking, talking and laughing with your enemy. You...",
    response: "Kept faith in her and ignored.",
  },
  {
    id: 53,
    text: " He was going to the neighboring village on his cycle to get medicine for his ailing mother. The cycle got a puncture and it was getting dark. He...",
    response:
      "Took the cycle to the nearest mechanic and got it repaired, took the medicine, and reached home.",
  },
  {
    id: 54,
    text: "While traveling in a train, he saw that a compartment caught fire. He...",
    response:
      " Pulled the chain, evacuated the compartment, informed the authority, and helped in extinguishing.",
  },
  {
    id: 55,
    text: "You did not get selected in SSB Interview. You...",
    response:
      "Analyzed and improved the previous mistakes, put in extra effort, and cleared it.",
  },
  {
    id: 56,
    text: "His girlfriend wants to go to the movie, while other friends suggest going for a picnic. He...",
    response:
      "He convinced her to picnic and go on an evening show after the picnic.",
  },
  {
    id: 57,
    text: "While playing football final match he hurt his knee. He...",
    response: "Replaced himself with extras and supported the team morally",
  },
  {
    id: 58,
    text: "In a train journey, at mid-night certain sound disturbed your sleep. On being woken up, you found someone trying to steal through the window. You...",
    response:
      "Grabbed the hand, alerted the co-passengers and got the train stop, and handed him over to RPF.",
  },
  {
    id: 59,
    text: "Infield area, he was short of manpower; one of his jawans asks for the leave on the wrong excuse which he knows is false. He...",
    response: "He denied and took disciplinary action.",
  },
  {
    id: 60,
    text: "He was going for an interview, while on his way he saw an injured man dragging himself on the footpath, He...",
    response:
      "He called an ambulance and got him admitted and went for the interview.",
  },
];
